import React from 'react';

class DatePickerCustomInput extends React.Component<any> {
    public render() {
        return (
            <input className="form-control" onClick={this.props.onClick} onChange={this.props.onClick} value={this.props.value} placeholder={this.props.placeholder} />
        );
    }
}

export default DatePickerCustomInput;


// WEBPACK FOOTER //
// ./src/components/Form/DatePickerCustomInput.tsx